<template>
  <main-layout>
    <template>

      selectedAdvertisers {{JSON.stringify(this.getMultiplySelectAdvertisers)}}


      <div class="search_btn_wrap flex jcsb v_center">
        <div class="search_wrapper">
          <v-text-field
                  v-model="table.searchAdvertisers"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
          ></v-text-field>
        </div>
      </div>

      <v-data-table
              :headers="table.headers"
              :pagination.sync="this.pagination"
              :rows-per-page-items="this.pagination.rowsPerPageItems"
              :total-items="getSflAdvertisers.length"
              :loading="loading"
              :items="getSflAdvertisers"
              show-select
              class="elevation-1"
              @input="enterSelect($event)"

      >
        <template v-slot:header.id="{ header }">
          <a
                  @click="sortColumn('id')"
          >
            <span class="header_title">{{header.text}}</span>
            <v-icon size="16" color="#7F98A5"> {{table.switchSortIcon.id.icon}}</v-icon>
          </a>
        </template>

        <template v-slot:header.name="{ header }">
          <a @click="table.showFilters.offer = !table.showFilters.name">
            <v-icon size="16" color="#7F98A5">{{table.showFilters.name || table.activeFilters.name ? 'mdi-filter' :
              'mdi-filter-outline'}}
            </v-icon>
          </a>
          <a
                  @click="sortColumn('name')"
          >
            <span class="header_title">{{header.text}}</span>
            <v-icon size="16" color="#7F98A5"> {{table.switchSortIcon.name.icon}}</v-icon>
          </a>

        </template>

        <template v-slot:header.actions="{ header }">
          <span class="header_title">{{header.text}}</span>
        </template>

        <!--body-->
        <template v-slot:item.id="{item}">
          <td class="td_title" :style="{height: table.heightCounter + 'px'}">
            {{item.id}}
          </td>
        </template>
        <template v-slot:item.name="{item}">
          <span class="td_title">
            {{item.name}}
          </span>
        </template>

        <template v-slot:item.actions="{item}">
            <span
                    class="td_title"
            >
              <v-icon size="16" color="#7F98A5" style="cursor:pointer;">mdi-content-copy</v-icon>
            </span>
        </template>
      </v-data-table>
    </template>
  </main-layout>
</template>

<script>
  import {mapGetters, mapActions, mapMutations} from 'vuex'
  import store from '../../../store'
  import {getCookie} from "@/helpers"
  import MainLayout from "../../layouts/MainLayout"

  export default {

    data() {
      return {
        alertForCopy: false,
        alert: {
          showAlert: false,
          title: '',
          type: 'success'
        },
        pagination: {
          descending: true,
          page: 1,
          rowsPerPage: 4,
          sortBy: 'fat',
          totalItems: 0,
          rowsPerPageItems: [1, 2, 4, 8, 16]
        },
        table: {
          heightCounter: 48,
          loading: false,
          searchAdvertisers: '',
          pageChangedByMe: false,
          currentPage: 1,
          perPage: 10,
          pageOptions: [25, 50, 100, 200, 500],
          orderBy: '',
          sortColumnsAsc: {
            id: null,
            name: null,
          },
          switchSortIcon: {
            id: {switch: false, icon: 'mdi-sort'},
            name: {switch: false, icon: 'mdi-sort'},
          },
          showFilters: {
            id: false,
            name: false,
          },
          activeFilters: {
            id: false,
            name: false,
          },
          selectedFilters: {
            id: [],
            name: [],
          },
          selectedAdvertisers: [],
          headers: [
            {text: 'Id', value: 'id', class: 'color', align: 'center'},
            {text: 'Name', value: 'name', align: 'center'},
          ]
        },
      }
    },

    async mounted() {
      store.dispatch('advertisers/saveSflAdvertisersStore')
    },
    components: {
      // MainLayout,
    },
    methods: {
      ...mapMutations('advertisers', ['saveMultiplySelectAdvertisers']),
      enterSelect(values) {
        // console.log('enterSelect:', values)
        this.table.selectedAdvertisers.length = 0
        let formatAff = values.map(i => (i.id)).join(",");
        this.table.selectedAdvertisers.push(formatAff)
        this.saveMultiplySelectAdvertisers(formatAff)
        let obj = {}
        obj.searchFilter = this.getMultiplySelectAdvertisers
        store.dispatch('offers/saveOffersStore', obj)
      },
      async submitSearch(){
        this.table.loading = true
        let search = this.table.searchAdvertisers.length  === 0 && '' ||  this.table.searchAdvertisers
        await store.dispatch('advertisers/saveSflAdvertisersStore', {
          search: search,
          token: getCookie('accessToken')
        })
        this.table.loading = false
      },
      ...mapActions('alert', ['ALERT_SUCCESS', 'ALERT_ERROR', 'ALERT_INFO', 'ALERT_WARNING', 'ALERT']),
    },
    watch: {
      'table.searchAdvertisers'() {
        if(this.table.searchAdvertisers.length > 1) {
          return this.submitSearch()
        }
        if(this.table.searchAdvertisers === '') {
          return this.submitSearch()
        }
      }
    },
    computed: {
      ...mapGetters('advertisers', ['getSflAdvertisers', 'getMultiplySelectAdvertisers']),
    }
  }
</script>
